export const empty = () => {
    // Do nothing
};
export const runAll = (...fns) => () => fns.forEach((fn) => fn());
const apply = (arg) => (fn) => {
    fn(arg);
    return arg;
};
export const dates = {
    never: () => null,
    yesterday: () => apply(new Date())((date) => date.setDate(date.getDate() - 1)),
    tomorrow: () => apply(new Date())((date) => date.setDate(date.getDate() + 1)),
    days: (days) => () => apply(new Date())((date) => date.setDate(date.getDate() + days)),
    nextWeek: () => apply(new Date())((date) => date.setDate(date.getDate() + 7)),
    weeks: (weeks) => () => apply(new Date())((date) => date.setDate(date.getDate() + weeks * 7)),
    nextMonth: () => apply(new Date())((date) => date.setMonth(date.getMonth() + 1)),
    months: (months) => () => apply(new Date())((date) => date.setMonth(date.getMonth() + months)),
    nextYear: () => apply(new Date())((date) => date.setFullYear(date.getFullYear() + 1))
};
